import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Col, Typography, Icon } from "witmeg-ui-system";
import "./Layout.scss"
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { getCurrencyFormat, getLocalStorageData, LOCAL_STORAGE_ITEMS_NAMES } from "../../../RestaurantWidget/utilities/helper/helper";
import { addToCart, deleteCartItem, getCartItemsToCart, updateCartItemQuantity } from "../../../RestaurantWidget/utilities/api/restaurantsService";
import deal from "../../assets/deal.png"
import deleteIc from "../../assets/trash.svg"

import DeletePopup from "../Cart/DeletePopup";
import { setOrderCartItems, setOrderData, setOrderEmpty } from '../../../../../../../redux/resturantWidgetSlice';
import CustomPopup from '../Cart/CustomPopup';
import { getTemplateData } from '../../../RestaurantWidget/utilities/api/voucherService';

const IMAGE_PLACEHOLDER = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQMAAADCCAIAAADCcDA5AAAStUlEQVR4Ae2dPY+ruhaGz9863e5GqSiRaCxRJA0tCj11poo0EjUVXST+QSqaVClpERIdSC5MdedmbXzYJGHCh7P5eCkGD8HGfr0elm2w+afABgWgQFH8AxGgABQoQAKMAAqQAvAJsAQo8H8FQALsAAqABNgAFKgUgE+olMB+3QqAhHXXP0pfKQASKiWwX7cCIGHd9Y/SVwqAhEoJ7NetAEhYd/2j9JUCIKFSAvt1KwAS1l3/KH2lAEiolMB+3QqAhHXXP0pfKQASKiWwX7cCIGHd9Y/SVwqAhEoJ7NetAEhYd/2j9JUCIKFSAvt1KwAS1l3/KH2lAEiolMB+3QqAhHXXP0pfKQASKiWwX7cCIGHd9Y/SVwqAhEoJ7NetAEhYd/2j9JUCIKFSAvt1KwAS1l3/KH2lAEiolMB+3QqAhHXXP0pfKQASKiWwX7cCIGHd9Y/SVwqAhEoJ7NetAEhYd/2j9JUCIKFSAvt1KwAS1l3/KH2lAEiolMB+3QqAhHXXP0pfKQASKiWwX7cCIGHd9Y/SVwqAhEoJ7NetAEhYd/2j9JUCIKFSAvt1KwAS1l3/KH2lAEiolMB+3QosjQTOuRCiKIocmxoFiqIQQnDOFwbOokjgnIdh6DjODptKBRzHCcOQ37bF8LAcErIscxzHMIwtNvUKGIbhOE6WZSBhWgp8+2vbtk3T3G63pmka2FQqIHW2bZvaotOyhl65WYJP4Jyfz2fyBoyx4/EYY1OpwPF4ZIxtt1vDMM7n8zL6DEsgQQhxOBzM23Y4HMqypCYs/ipSoCxLEny73R4Oh2W4hSWQwDnf7/fb7VbX9SiKlnGL6uXh3xSJc365XHRd3263+/1+GYIvhATbtomEy+WyjIp5k1H3ukydBNu2lyE4SOhlC+uOBBImWv/frWH4hHfWDUh4p9odrgUSOog1xqkgYQwVFaQBEhSI2pYkSGhT5y/+BhLeLD5IeLPgr14OJLyq1EjngYSRhBw7GZAwtqI/pAcSfhDob/0MEt6sPEh4s+CvXg4kvKrUSOeBhJGEHDsZpSTQ1B9x25bxMHW4/CBhuIZKUlBEghAiz/Moik6nUxAEYRher1c5J05JSWaSKEiYaEWNToIQIk3T4/FIL/kzxkzTZIwZhsEYC4KgKIo1+weQsAoShBBRFJH1P5z7xRizLCuO49XCABKWTwJhQO8bP8RAHmSMJUmyThhAwvJJSNP0FQyIB8uyQALeyp4QFWP1E4QQx+ORJunKe39LgDEWhuEyZmx1qk74hE5yve/ksUhI05Sm57ZYf+Onv3VHpFHdvzW2CxLeZ9ydrjQKCZzzKIq6LhJjGEaSJJ1yO/BkIUSWZWEYep53PB5936c59e9sp4GEgZWoKvpYJARB0NUn6Lr+zvminHPf92kwl1YwoCVtTNM8n89va6eBBFWmPDDdUUgQQvi+35UEwzDeuYaA67rPvJau60EQvAcGkDDQYlVFH4UEzvnpdOpKwtt8ghDi6+urPXu0+tAbYAAJqkx5YLpjkTDZfoIQ4nw+vzK8yxhL03Sgnj9GBwk/SvR3ThiFhKIosix7fQiVBpHesNoP5zzLsnZvIEe0TNN0HKcsS6U1ARKUyts/8bFIEEJ4nvc6DO9ZC5Fz7rpup1ydTielbSSQ0N9YlcYciwT66sKzLqm871KA7r5KDY6+VHA6nV7MksyhYRhKX4sCCUrtuX/iI5LAOb9erz9aHt2hVa+ZzjmP4/iV7oFkQAaUvgkCEvobq9KYI5JAt+E4ji3LetY013Xddd0sy1Q/zMrz3LIsadydAowxz/MUdRhAglJ77p/4uCTQ3IM8z4MgoLVW6UmWYRi6rluW9Z5numVZep73jMZXqFD3rAMk9DdWpTFHJ4FyS2/1xHF8vm1RFCVJQkvSKy0OoRhFUb92UR0S0zRVNOFAgmoD6Jm+IhIoN9+Jy61n/rpHy7KsbtC9w6Zpuq47ehsJJHSv0rfE+LbUJa0QLIToNGzazolhGKO/Og4S3mLX3S+yJBKEEGEY/jh41W79jV8ZY+MOqoKE7kb6lhiLIYGGTcfFgKiwLGvERx8g4S123f0iiyHhu69MzbzGTX34v4wx3/fHggEkdDfSt8RYBgllWfZ4Lfx1SAzDoPWahtcJSBiuoZIUFkACPdsePmzaDoZpmnmeD68DkDBcQyUpLICEPM93u127HQ//1TRN+krvwGoACQMFVBV97iTI70kPt/UfUxhlNg9IUGXKA9OdNQk0C0fFeNEzKoavWQYSBlqsqujzJYFzniTJkJeLnpl7y3HTNPf7/ZBxJJCgypQHpjtrEhzHeX0WTot9d/qJ1jnuDQNIGGixqqLPlISyLHusK9PJ4ltOHjKoChJUmfLAdOdIwnuGTVtIoJ/6KQ8S+ummPJZqEuRndUacmjNkFs6P9v3iCYyx4/HY401VkKDcpvtdQBEJBECSJOfzObhtURTled67eS1LR0sRv7mj/BCPfoOqIEFW5bQCKkigUZ3D4aDrOs1ZY4zpuk4v8Hxfsbd/eH3xooe2O/rBHkskgYRpASBzMzoJQojr9frsszqMMcdx8jzvAQPnPE3T9w8WtfDTY4kkkCBtb1qBcUkgDNofddGQfA8Yxp2F02LfnX4yDKPTEkkgYVoAyNyMSIIQIo7jV1rwdCvt9OlBIUSPxYs62XTvkzstkQQSpO1NKzAWCV3XFzJN07btFz1D18R723TviLvd7sX2HkiYFgAyN6OQQJb6ijeomxrB8KJnUDQLp56fIWFaIumVkTGQIG1vWoHhJLzeKLo3tVf6DMMXL7q/roojLy6RBBKmBYDMzUAS+nmDuiG2N5Pou1WqZ+HU8zMk/MoSSSBB2t60AkNIIAyGD2u2eIaxFi8aYt+vx31liSSQMC0AZG56k0AYtA+YdrKh+w501zXfX7+cujN/XCIJJEjbm1agHwn0FHlce2p0oOk1O03Txr3KG1JjrUskgYRpASBz04MEwmAsb1A3zUafQcVKXvXLqQu3LJEEEqTtTSvQlQQV3qBukQ3PQDDMpccsC9KyRBJImBYAMjedSCAMhneRpcU8DDQ60GVZjr7G48PrjnvQMIyHX5sGCdL2phV4nYT3YEDmuIxm0sMlkkDCtACQuXmRBHoP9A3LCskbc6OZRJ5hXs2kh0skgQRpe9MKvEICYdD1ZQpp070DDc8wx2bS/aAqSJgWADI3P5JAGPT+ZllvDChiwzPMsQPdWCIJJEjbm1agnQT6svdAax4YfQGewbZt+XIeSJgWADI3LST8XW9Q56cBw+w8Q32JJJAgbW9agWckkDewLEv1mGnd4lvCDRhm12eQSySBhGkBIHPzkATCYLfbTQQDImTuMHzn/1ttkCBtb1qBexI4599TyWzbnhQGdRjk5J55NZNM06Qlki6XCw0H27b94ky3aRnNXW7+uTsyvwP3JNDnCCaIQR2GLMvIhubVTKIlkq7XK0iYHCoNEibrDepdiEYzaXae4Xw+0/uL8AkT4kGSQJMPp9koqmOwAM8giwMSpkiCtDBZTxMPzNozkLYgYbokTNz6G9mbOwwgASQ0TLr/vwSD7EBTn0HFLKL+WXweEySAhOfW0f0XgkEOrdK3mSc79lUvH0gACXV7GCFc9wxCiCiKZuEWQMK0SHAcZwRj/NtJEAzxbZv4gnlSKsdx8GRtKjDQhzlm0ZaQBtQSMG5bywnT+YkeOct3VKdiEL3ysZBnzPKR53SsZA050XX9er3CJ/RCT00kcguzaFgvhhDDMPp9pk2NCQxNdQk+gTTgnPu+T1+CWkxLaYLYmKbJGDMMw/f9ZXgDsp/lkFAUBS157fu+i02ZAofDwff9OI6X0T2QrmRRJNB4vLhtZVlSAH9VKLAkb7BAnyD5RgAKdFVgaT6ha/lxPhQgBUACLAEK/F8BkAA7gAIgATYABSoF4BMqJbBftwIgYd31j9JXCoCESonb/ntK9LOR8mfH/4j//B8hxMAUnqeNX0ZQACT8J2KWZWEYRlF0b7JJkoRhmOf5f2d3CaVpejqd4jjuEgnnvlUBkPBbbvoOp6ZphmFkWVavBFry7devX43j9XNawpTyv//++5Cxloj46Z0KgITfapO90rtlYRjWX6ohEjRN60dCURRxHDPGHn6p6Z2VjWu1KAAS/iBB07QgCBhj9QbScBI452VZ1tNsqRL89FcUAAl/kLDZbJIk0XX9fD5Lw31IgjRuGWivv7qTod6zjEhvyNHrgwSMPFJPkw5yzh/+SsfzPK+fVo9OJzyLXj9znWGQ8LveqXX08fGRZdn3m/f3H86ot47oy4Wu6xqGoeu64zjtU7eyLDsej0mSkLkfj8coir6j2LZNq4uGYViW5eVy2e/3uq6bphkEQR2eoih83zdNU9f13W53Op0kqJTm9Xq1LIvinm/b4XCQ5wghzucznbDdboMgkD+t0+7vSw0SmiSkaZokiaZp0rjvfQL5jcPhcL1tnudtNht5/r3KWZb9+vUrjmO6Jdu2TUsQRFEUx7Hv+5qmfX5+MsaiKEqSJAgCTdNkd0UIcTgcTNOk8+lX6bVkX9/zvDiOCQnrtpG5Ewaapp3P5yRJLpeLaZpfX18N0u6zvaojIOF3dUufkCRJWZaH20a20iChLMvj8UhOg54/0JH9fv/MtrIs+/j4kCTs9/vtdpumKTWTyrIk91I/8vn5ud/vyZTTNN1sNpfLpX7+4XCgy1F013VloytNU8aYZVkUPc9zcjKy6RXHsaZp5KNWZe4thQUJD0ggKjabDT0BaJDAOb/vSFyv1xbbapBg27bv+xIbIYTnebZtl2VJuaFl8MiUKTOu68qRKyGE7/uO48gU6H4vGzzkQ2T06/VKrT5pB2VZ0uLvMor8abUBkPC76us+gSaC7vd7z/PoPnq5XKifQB9uI0jqZpSmqaZpz8ZJh5AgJ+JJGy3L0vM8SUKSJB8fH/W2mRAiCILdbkcu63w+67ouPQb11B3Hue+KyEusMAASHpPAOY+iaLPZfH+Noe4TOOd0+0/TtGEuDUdR/3UgCZQU9TGKoqBvF8jmEFGaJIkkk3MehiGRQFRst9skSWhNMfrrOI7nedKr1HO7zjBI+F3vDZ9Ad+LdbhcEAY3qSJ8QRZGu67KtIs1U1/UwDKU51u1pOAm0WIHneYZh7HY7mq9Pt3m65dfJpC7ydrsleHzfZ4ztdrv6ShmWZdVbaPXcrjMMEn7X+z0J1Fg3TbMoinrr6P0k0H1d0zTXdS+XS1mWQRBQ64hzTiTUyaSDdRIsy6JmHrWX5N91Gv3DUoOEpySQW6DOKLWIaGF3IqF+Dy6KIs/zRre1LvcQnyDbY/TMgW7zdRLo43/1/BDD9dbRbreT3XHKGPmTeiZXHgYJvw3g3idQv5mestVJoCFIGhKV1qOux0wjRaZpyjY9uYh6j7nRg2/0mMMwNAxDRqdyBUGANwJl9WEe839SPCShKAp6yhYEgewb5Hm+2Wzkgy1yHQ8dhUx9iE+4H2OlxxfUY6ZLNNyREOLz81OOol4ul8YoqhCipX8vs72qAHzC7+p+RgJZFS2BSG3xsiwdx3FdV7Y3yrL8/PyUN+l7AxpIgnwpULbvTdOUJFB+HMeh/NAn2U3TlE/WsiwzDON0OtEJ1PluuJH7PK/tCEj4g4Rfv341nrwSIbquy3kLdETTtK+vr+S2fbc0Or1t0Ri3EUJ8fX1Rp5ZyI4Q4nU7ygQC1x+hy9LaSbduMMXqGIDsSdEIcx5Zl7XY7SQJ1G8hvJElyvV6XtNr7WMSChP+UTJLEdd1611Paped5n5+fcnxGCHG9Xh3H0W+bbdtRFNUb4v8legtlWea6rnxi7XlefbyVhv/ro/v0NOP7wTONycpRUU3TGGOn0ynLMue20UXpGzy73Y5mGoW3jUCSRaAnDLquM8YWtrhvQ+1+/4KEP3R7Zs33L0JTQyW/bRT+I6G7f+op358vn5rJeI0jFIVQJDzqiQghaJBUtt/kM+Z6gpxzmoBaz4w8YeUBkDB7A6CeTP3VCSGE67ot/ZbZl1lBAUCCAlHfmyTn/HQ6aZpGo6Kcc+q3YJC0Uz2AhE5yTfRkeuag6/rmtjHG5NyGieZ4etkCCdOrk145EkJkWXa9XuM4pjmcvZJZbySQsKi6r3ejF1Uw9YUBCeo1xhXmoABImEMtIY/qFQAJ6jXGFeagAEiYQy0hj+oVAAnqNcYV5qAASJhDLSGP6hUACeo1xhXmoABImEMtIY/qFQAJ6jXGFeagAEiYQy0hj+oVAAnqNcYV5qAASJhDLSGP6hUACeo1xhXmoABImEMtIY/qFQAJ6jXGFeagAEiYQy0hj+oVAAnqNcYV5qAASJhDLSGP6hUACeo1xhXmoABImEMtIY/qFQAJ6jXGFeagAEiYQy0hj+oVAAnqNcYV5qDA/wB2ys2dB7jqeAAAAABJRU5ErkJggg==';
const Layout = ({ layout }) => {
    const [isDeleteItem, setIsDeleteItem] = useState("")
    const [isLoading, setIsLoading] = useState("")
    const [isIncreasing, setIsIncreasing] = useState(false)
    const [isDecreasing, setIsDeccreasing] = useState(false)
    const [isCustomOpen, setIsCustomOpen] = useState(false)
    const [templateData, setTemplateData] = useState([])



    const dispatch = useDispatch()
    const restaurantDataState = useSelector((state) => state.resturantData);
    const { menuData: { storage: { data } }, currency, menuData, orderCartData, voucherData
    } = useSelector((state) => state.resturantData);
    const { companyDetails } = useSelector((state) => state.companyData);
    const currencyFormat = getCurrencyFormat(currency);
    const selectedOrderType = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).selectedOrderType
    const getThePrice = (price) => {
        let priceValue;

        switch (selectedOrderType) {
            case "delivery":
                priceValue = price.DeliveryPrice;
                break;
            case "table":
                priceValue = price.TablePrice;
                break;
            default:
                priceValue = price.PickupPrice;
                break;
        }
        return currencyFormat(priceValue / 100);
    };
    const findItemFromCart = (menuItem) => {
        let isAvailable = null
        if (!orderCartData?.Items) {
            return isAvailable
        }
        if (orderCartData?.Items?.length === 0) {
            return isAvailable
        }
        else {
            let found = orderCartData?.Items?.filter((item) => item.CartItemID === menuItem.MenuItemID)[0]
            isAvailable = found
        }
        return isAvailable

    }
    const updateTotalPrice = (price, quantity) => {
        const createPriceObj = (priceValue, quantity) => ({
            Amount: priceValue * quantity,
            FormattedText: currencyFormat((priceValue * quantity)),
            FormattedAmount: Number(((priceValue * quantity)).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.Delivery.Amount || 0, quantity),
            TakeAway: createPriceObj(price?.TakeAway.Amount || 0, quantity),
            DineIn: createPriceObj(price?.DineIn.Amount || 0, quantity),
            CurrencyCode: "GBP"
        });
        const totalPrice = getPriceData(price, quantity);
        return totalPrice
    }
    const increaseQty = (item) => {
        setIsIncreasing(true)
        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount + 1,
            "CountryISOCode": "GB"
        }
        const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
            itemValue.ID === item.ID
                ? {
                    ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount + 1 }, PriceInfo: {
                        ...itemValue.PriceInfo,
                        BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount + 1),
                        TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount + 1)

                    }
                }
                : itemValue
        );
        dispatch(setOrderCartItems(updatedArray))
        updateCartItemQuantity(data).then((response) => {
            dispatch(setOrderData(response))
            setIsIncreasing(false)
        })
    }
    const decreaseQty = (item) => {
        setIsDeccreasing(true)
        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount - 1,
            "CountryISOCode": "GB"
        }
        if (data.NewQuantity > 0) {
            const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
                itemValue.ID === item.ID
                    ? {
                        ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount - 1 }, PriceInfo: {
                            ...itemValue.PriceInfo,
                            BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount - 1),
                            TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount - 1),
                        }
                    }
                    : itemValue
            );
            dispatch(setOrderCartItems(updatedArray))
            updateCartItemQuantity(data).then((response) => {
                dispatch(setOrderData(response))
                setIsDeccreasing(false)

            })

        } else {
            let cartArray = restaurantDataState.orderCartData.Items.filter((cartItem) => cartItem.ID !== item.ID)
            dispatch(setOrderCartItems(cartArray))
            deleteCartItem(item.ID).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                        let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                        getCartItemsToCart(customerID, cloud).then((response) => {
                            if (response) {
                                console.log(response, "response")
                                dispatch(setOrderData(response))
                            }
                        })
                        setIsDeleteItem("")
                    }
                    else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                    }
                    setIsDeccreasing(false)
                }
            })
        }
    }
    const deleteItem = () => {
        if (isDeleteItem !== "") {
            deleteCartItem(isDeleteItem).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                        let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                        getCartItemsToCart(customerID, cloud).then((response) => {
                            if (response) {
                                console.log(response, "response")
                                dispatch(setOrderData(response))
                            }
                        })
                        setIsDeleteItem("")
                    } else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                    }
                }
            })
        }
    }
    const renderLayout1 = (menuItem) => {
        const item = findItemFromCart(menuItem)
        return (
            <div className="column">
                <div className="item-details">
                    <div className="item-dela-cont">
                        <img style={{ objectFit: !menuItem.ImageURL ? "fill" : "" }} alt="" src={menuItem.ImageURL ? menuItem.ImageURL : IMAGE_PLACEHOLDER} className="item-image" />
                        {menuItem?.MetaData?.IsDealProduct && <div className="dea-cont "> <img alt="" src={deal} className="deal" /></div>}
                    </div>
                    <div className="item-des">
                        <div className="item-des-title">
                            <div className="name">{menuItem.Title.en.toCapitalFirst()}</div>
                            <div className="price">
                                {getThePrice(menuItem.PriceInfo.Price)}
                            </div></div>

                        <div className="details">{menuItem.Description.en.toCapitalFirst()}</div>
                    </div>
                </div>
                <div className="column-right-container">
                    <div className="column-right-container-inner">
                        {item ?
                            <div className="quantity">
                                <div className={!isDecreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                    if (!isDecreasing) {
                                        decreaseQty(item)
                                    }
                                }}>
                                    {item?.Quantity.Amount === 1 ? <img alt='' src={deleteIc} className='delete-icon' /> : <Icon name="minus" className="icon" />}
                                </div>
                                <div className="qty-cont">
                                    {item?.Quantity.Amount || 0}
                                </div>

                                <div className={!isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                    if (!isIncreasing) {
                                        increaseQty(item)
                                    }
                                }}>
                                    <Icon name="plus" className="icon" />
                                </div>
                            </div> : <div className="add-to-cart-btn" onClick={() => {
                                if (isLoading !== menuItem.MenuItemID) {

                                    addItemToCart(menuItem)
                                }
                            }}>{isLoading === menuItem.MenuItemID && <div className='loader-btn ' />}Add to cart</div>}

                    </div>
                </div>

            </div>
        )
    }
    const renderLayout2 = (menuItem) => {
        const item = findItemFromCart(menuItem)
        return (
            <div className="column">
                <div className="item-details">
                    <div className="item-dela-cont">
                        <img style={{ objectFit: !menuItem.ImageURL ? "fill" : "" }} alt="" src={menuItem.ImageURL ? menuItem.ImageURL : IMAGE_PLACEHOLDER} className="item-image"
                        />
                        {menuItem?.MetaData?.IsDealProduct && <div className="dea-cont "> <img alt="" src={deal} className="deal" /></div>}

                    </div>
                    <div className="item-des">
                        <div className="item-des-title">
                            <div className="name">{menuItem.Title.en.toCapitalFirst()}</div>
                            <div className="price">
                                {getThePrice(menuItem.PriceInfo.Price)}
                            </div></div>

                        <div className="details">{menuItem.Description.en.toCapitalFirst()}</div>
                        <div className="price-container">
                            {item ?
                                <div className="quantity">
                                    <div className={!isDecreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                        if (!isDecreasing) {
                                            decreaseQty(item)
                                        }
                                    }}>
                                        {item?.Quantity.Amount === 1 ? <img alt='' src={deleteIc} className='delete-icon' /> : <Icon name="minus" className="icon" />}
                                    </div>
                                    <div className="qty-cont">
                                        {item?.Quantity.Amount || 0}
                                    </div>

                                    <div className={!isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                        if (!isIncreasing) {
                                            increaseQty(item)
                                        }
                                    }}>
                                        <Icon name="plus" className="icon" />
                                    </div>
                                </div> : <div className="add-to-cart-btn" onClick={() => {
                                    if (isLoading !== menuItem.MenuItemID) {

                                        addItemToCart(menuItem)

                                    }
                                }}>{isLoading === menuItem.MenuItemID && <div className='loader-btn ' />}Add to cart</div>}

                        </div>
                    </div>
                </div>

            </div>
        )
    }
    const renderLayout3 = (menuItem) => {
        const item = findItemFromCart(menuItem)
        return (
            <div className="column">
                <div className="item-details">
                    <div className="item-dela-cont">
                        <img style={{ objectFit: !menuItem.ImageURL ? "fill" : "" }} alt="" src={menuItem.ImageURL ? menuItem.ImageURL : IMAGE_PLACEHOLDER} className="item-image"
                        />
                        {menuItem?.MetaData?.IsDealProduct && <div className="dea-cont "> <img alt="" src={deal} className="deal" /></div>}

                    </div>
                    <div className="item-des">
                        <div className="item-des-title">
                            <div className="name">{menuItem.Title.en.toCapitalFirst()}</div>
                            <div className="price">
                                {getThePrice(menuItem.PriceInfo.Price)}
                            </div></div>

                        <div className="details">{menuItem.Description.en.toCapitalFirst()}</div>
                        <div className="price-container">
                            <div className="price">
                                {getThePrice(menuItem.PriceInfo.Price)}
                            </div>
                            {item ?
                                <div className="quantity">
                                    <div className={!isDecreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                        if (!isDecreasing) {
                                            decreaseQty(item)
                                        }
                                    }}>
                                        {item?.Quantity.Amount === 1 ? <img alt='' src={deleteIc} className='delete-icon' /> : <Icon name="minus" className="icon" />}
                                    </div>
                                    <div className="qty-cont">
                                        {item?.Quantity.Amount || 0}
                                    </div>

                                    <div className={!isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                        if (!isIncreasing) {
                                            increaseQty(item)
                                        }
                                    }}>
                                        <Icon name="plus" className="icon" />
                                    </div>
                                </div> : <div className="add-to-cart-btn" onClick={() => {
                                    if (isLoading !== menuItem.MenuItemID) {

                                        addItemToCart(menuItem)

                                    }
                                }}>{isLoading === menuItem.MenuItemID && <div className='loader-btn ' />}Add to cart</div>}

                        </div>
                    </div>
                </div>

            </div>
        )
    }
    const getLayout = (menuItem) => {
        let layoutComponent;

        switch (layout) {
            case "layout1":
                layoutComponent = renderLayout1(menuItem);
                break;

            case "layout2":
                layoutComponent = renderLayout2(menuItem);
                break;
            case "layout3":
                layoutComponent = renderLayout3(menuItem);
                break;
            default:
                layoutComponent = renderLayout1(menuItem);
                break;
        }

        return layoutComponent;
    };
    const getOrderType = () => {
        let type;
        switch (selectedOrderType) {
            case "delivery":
                type = "DELIVERY_BY_REWARDCONSUMER";
                break;
            case "table":
                type = "DINE_IN";
                break;
            case "collection":
                type = "TAKE_AWAY";
                break;
            default:
                type = "DELIVERY_BY_REWARDCONSUMER";
                break;
        }
        return type
    }
    const getItemPriceForCart = (option, quantity) => {
        const createPriceObj = (price, quantity) => ({
            Amount: price * quantity,
            FormattedText: currencyFormat((price * quantity) / 100),
            FormattedAmount: Number(((price * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.DeliveryPrice || 0, quantity),
            TakeAway: createPriceObj(price?.PickupPrice || 0, quantity),
            DineIn: createPriceObj(price?.TablePrice || 0, quantity),
            CurrencyCode: "GB"
        });

        const basePrice = getPriceData(option?.Price || {}, 1);
        const totalPrice = getPriceData(option?.Price || {}, quantity);
        return {
            BaseUnitPrice: basePrice,
            BaseTotalPrice: quantity > 1 ? totalPrice : basePrice
        };
    };
    const addItemToCart = async (selectedItem) => {
        setIsLoading(selectedItem.MenuItemID)
        const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
        const userDetails = localStorage.getItem('fullUserDetails')
        let parsedUserDetails = JSON.parse(localStorage.getItem('fullUserDetails'))
        let customer = {
            ID: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
            Name: {
                DisplayName: userDetails ? parsedUserDetails.UserName : "",
                FirstName: userDetails ? parsedUserDetails.FirstName : "",
                LastName: userDetails ? parsedUserDetails.LastName : "",
            },
            Email: userDetails ? parsedUserDetails.Email : "",
            IsPrimaryCustomer: true

        }
        let cartObject = {
            "CartItemID": selectedItem.MenuItemID,
            "Title": selectedItem.Title?.en,
            "CustomerID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
            "Quantity": {
                "Unit": "pcs",
                "Amount": 1
            },
            "DefaultQuantity": {
                "Amount": 1,
                "Unit": "pcs"
            },
            "CustomerRequests": {
                "Allergy": {
                    "Allergens": [],
                    "Instructions": ""
                },
                "SpecialInstructions": ""
            },
            SelectedModifierGroups: [],
            Id: uuidv4(),
            ID: "",
            ModifierGroupRules: selectedItem.ModifierGroupRules,
            Image: selectedItem.ImageURL,
            PriceInfo: getItemPriceForCart(selectedItem.PriceInfo, 1),
            MetaData: {
                IsVoucher: true,
                Type: "STANDARD",
                TemplateID: "",
                ExpiryDate: "",
                ProductID: selectedItem?.MetaData?.ProductID

            }

        }
        let cart = {
            "OrderID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) : '',
            "StoreID": val.cloudLocationID,
            "ConsumerID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
            "OrderingPlatformType": "RETAILPACX",
            "CountryISOCode": "GB",
            "OrganizationID": val.organizationID,
            "CloudLocationID": val.cloudLocationID,
            "Name": companyDetails.shopName,
            "OrderFullFilmentType": getOrderType(),
            "Customers": [customer],
            Cart: cartObject
        }
        await addToCart(cart).then((res) => {
            if (res) {
                window.location.reload()
                setIsLoading("")
            }
        })
    }
    useEffect(() => {
        getData()
    }, [])
    const getData = async () => {
        const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
        let valueDate = await getTemplateData(val.cloudLocationID)
        if (valueDate) {
            setTemplateData(valueDate)
        }
    }

    useEffect(() => {
        if (data?.Categories?.length > 0) {
            const filteredItems = [];

            data.Categories.forEach((category) => {
                category.MenuEntities.forEach((menuEntity) => {
                    const menuItem = _.find(menuData?.storage?.data?.Items, { MenuItemID: menuEntity.ID });

                    if (menuItem?.MetaData?.CustomVoucher) {
                        filteredItems.push(menuItem);
                    }
                });
            });
            if (filteredItems.length > 0) {
                localStorage.setItem("ECOM_CUSTOM", JSON.stringify(filteredItems[0]))
            }
        }
    }, [data]);
    console.log(templateData, "emp")
    return (
        <div className="Voucher-navbar-Layout">
            {
                voucherData?.Settings?.CustomVoucher?.Enable && <div>
                    <Typography type="title" level={4} pattern="bold" className="title-vouchers" >Custom Vouchers</Typography>
                    <Typography className="sub-title-vouchers" >Personalize your gift voucher</Typography>
                    <div className='empty-voucer-container' onClick={() => {
                        setIsCustomOpen(true)
                    }}>
                        <div>
                            <div className='icon-add'>
                                <div className="icon">+</div>
                            </div>
                            <div className='text'>Create your own Voucher</div>
                        </div>
                    </div>

                </div>}
            <Typography type="title" level={4} pattern="bold" className="title-vouchers" >Standard Vouchers</Typography>
            <Typography className="sub-title-vouchers" >Choose from our predefined gift voucher options</Typography>


            {data.Categories && data.Categories.length > 0 ? data.Categories.map((data, index) => {
                return (
                    <div key={index} style={{ marginBottom: "20px" }}>
                        <div className={layout}>
                            {data.MenuEntities.map(((menuEntity, key) => {
                                const menuItem = _.find(menuData.storage.data.Items, { MenuItemID: menuEntity.ID });
                                if (!menuItem?.MetaData?.CustomVoucher) {

                                    return (
                                        <div className="column-styles" key={key}>
                                            {getLayout(menuItem)}
                                        </div>
                                    )
                                }
                            }))}
                        </div>
                    </div>
                )
            }) : <div className='empty-cont'>Vouchers not available</div>}

            <DeletePopup
                visibility={isDeleteItem !== ""}
                onPopupClose={() => {
                    setIsDeleteItem("")
                }}
                onDeleteConfirm={deleteItem} />
            <CustomPopup visibility={isCustomOpen} onPopupClose={() => {
                setIsCustomOpen(false)
            }}
                Data={templateData} />
        </div >
    )
}
export default Layout